import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import ReactTable from 'react-table'
import { Menu, Tooltip } from 'antd'
import { actions } from '../../redux/modules/templatesActions'
import history from '../../history'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
const propTypes = {}

class Templates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: this.props.match.params.templateType,
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      estimateItems: [],
      estimateGroups: [],
      defaultMarkup: 0,
      defaultOverhead: 0,
      addItemInput: '',
      addDescriptionInput: '',
      estimateTemplateName: ''
    }
  }

  componentWillMount() {
    this.props.templatesRefresh({ templateType: this.state.currentKey })
  }

  handleClick = e => {
    history.push(`/templates/${e.key}`)
    this.setState({
      currentKey: e.key
    })
    this.props.templatesRefresh({ templateType: e.key })
  }

  render() {
    const { payload } = this.props.templatesActions
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/templates">Templates</Link>
                </li>
              </ol>
            </nav>
            <h2>Templates</h2>
          </div>
          <Menu onClick={this.handleClick} mode="horizontal" selectedKeys={[this.state.currentKey]}>
            <Menu.Item key="estimate">Estimates</Menu.Item>
            <Menu.Item key="proposal">Proposals</Menu.Item>
            <Menu.Item key="contract">Contracts</Menu.Item>
            <Menu.Item key="material_request">Material Requests</Menu.Item>
            <Menu.Item key="work_order">Work Orders</Menu.Item>
            <Menu.Item key="job_minute">Job Minutes</Menu.Item>
            <Menu.Item key="driver_request">Driver Requests</Menu.Item>
            <Menu.Item key="repair_order">Repair Orders</Menu.Item>
            <Menu.Item key="service_order">Service Orders</Menu.Item>
            <Menu.Item key="contact_group">Contact Groups</Menu.Item>
            <Menu.Item key="change_order">Change Orders</Menu.Item>
            <Menu.Item key="form">Forms</Menu.Item>
          </Menu>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                {this.state.currentKey.replace('_', ' ')} templates
                <div
                  className="jobsBarAdd"
                  onClick={() => history.push(`/templates/${this.state.currentKey}/0`)}
                >
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">
                    NEW {this.state.currentKey.replace('_', ' ')} TEMPLATE
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e =>
                    history.push(`/templates/${this.state.currentKey}/${rowInfo.original.id}`)
                })}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        accessor: 'name',
                        Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                      },
                      {
                        Header: 'Description',
                        accessor: 'description',
                        Cell: d => (
                          <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                        )
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        width: 120,
                        Cell: d => {
                          const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ templatesActions }, ownProps) => ({ templatesActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

Templates.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Templates))



// WEBPACK FOOTER //
// ./src/containers/templates/index.js